import { DataAttributeDefinitions } from 'scrivito'

import { pisaListDataClass } from './Pisa/pisaListDataClass'

const attributes: DataAttributeDefinitions = {}

export const List = pisaListDataClass(attributes)
